export const STRINGS = {
  en: {
    app_name: "Riyadh-Nusantara FX",
    tagline: "Foreign Exchange Desk — SAR → IDR → USDT",
    login: "Sign in",
    logout: "Sign out",
    register: "Create account",
    email: "Email",
    password: "Password",
    name: "Full name",
    role: "Role",
    dashboard: "Dashboard",
    transactions: "Transactions",
    new_transaction: "New Transaction",
    customers: "Customers",
    rates: "Rates",
    users: "Users",
    reports: "Reports",
    profit: "Profit",
    today: "Today",
    total: "Total",
    volume: "Volume",
    live_rate: "Live Reference",
    manual_rate: "Manual Rate",
    buying: "Buying",
    selling: "Selling",
    save_rate: "Save Rate",
    convert: "Convert",
    from_amount: "Amount",
    to_amount: "You Get",
    leg_1: "Leg 1: SAR → IDR",
    leg_2: "Leg 2: IDR → USDT",
    net_payout: "Net USDT Payout",
    total_profit: "Total Profit (IDR)",
    submit_tx: "Save Transaction",
    print_receipt: "Print Receipt",
    export_csv: "Export CSV",
    add_customer: "Add Customer",
    phone: "Phone",
    id_number: "ID Number",
    address: "Address",
    notes: "Notes",
    status: "Status",
    completed: "Completed",
    pending: "Pending",
    cancelled: "Cancelled",
    search: "Search…",
    admin: "Admin",
    teller: "Teller",
    cashier: "Cashier",
    tx_number: "TX Number",
    date: "Date",
    customer: "Customer",
    profit_7d: "Profit (7d)",
    daily_profit: "Daily profit",
    receipt_thanks: "Thank you for your business",
    quick_convert: "Quick Convert",
    all_transactions: "All Transactions",
    add_user: "Add User",
    manage_users: "Manage Users",
    welcome: "Welcome back",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    from: "From",
    to: "To",
    fetch_live: "Refresh live rate",
    override: "Override",
    rate: "Rate",
    margin: "Margin",
    market: "Market",
    no_rate_set: "No manual rate configured. Set one under Rates.",
    tx_created: "Transaction saved",
    tx_saved_desc: "Receipt ready to print",
    rate_saved: "Rate updated",
    customer_saved: "Customer saved",
    logged_out: "Signed out",
    invalid_login: "Invalid credentials",
    branch: "Riyadh Branch",
  },
  id: {
    app_name: "Riyadh-Nusantara FX",
    tagline: "Layanan Penukaran Mata Uang — SAR → IDR → USDT",
    login: "Masuk",
    logout: "Keluar",
    register: "Buat akun",
    email: "Email",
    password: "Kata sandi",
    name: "Nama lengkap",
    role: "Peran",
    dashboard: "Dasbor",
    transactions: "Transaksi",
    new_transaction: "Transaksi Baru",
    customers: "Pelanggan",
    rates: "Kurs",
    users: "Pengguna",
    reports: "Laporan",
    profit: "Keuntungan",
    today: "Hari Ini",
    total: "Total",
    volume: "Volume",
    live_rate: "Referensi Live",
    manual_rate: "Kurs Manual",
    buying: "Beli",
    selling: "Jual",
    save_rate: "Simpan Kurs",
    convert: "Konversi",
    from_amount: "Jumlah",
    to_amount: "Diterima",
    leg_1: "Tahap 1: SAR → IDR",
    leg_2: "Tahap 2: IDR → USDT",
    net_payout: "Total Bayar USDT",
    total_profit: "Total Keuntungan (IDR)",
    submit_tx: "Simpan Transaksi",
    print_receipt: "Cetak Struk",
    export_csv: "Ekspor CSV",
    add_customer: "Tambah Pelanggan",
    phone: "Telepon",
    id_number: "No. Identitas",
    address: "Alamat",
    notes: "Catatan",
    status: "Status",
    completed: "Selesai",
    pending: "Tertunda",
    cancelled: "Dibatalkan",
    search: "Cari…",
    admin: "Admin",
    teller: "Teller",
    cashier: "Kasir",
    tx_number: "Nomor TX",
    date: "Tanggal",
    customer: "Pelanggan",
    profit_7d: "Keuntungan (7 hari)",
    daily_profit: "Keuntungan harian",
    receipt_thanks: "Terima kasih atas kepercayaan Anda",
    quick_convert: "Konversi Cepat",
    all_transactions: "Semua Transaksi",
    add_user: "Tambah Pengguna",
    manage_users: "Kelola Pengguna",
    welcome: "Selamat datang kembali",
    delete: "Hapus",
    edit: "Ubah",
    save: "Simpan",
    cancel: "Batal",
    from: "Dari",
    to: "Ke",
    fetch_live: "Segarkan kurs live",
    override: "Timpa",
    rate: "Kurs",
    margin: "Margin",
    market: "Pasar",
    no_rate_set: "Kurs manual belum diatur. Silakan atur di menu Kurs.",
    tx_created: "Transaksi disimpan",
    tx_saved_desc: "Struk siap dicetak",
    rate_saved: "Kurs diperbarui",
    customer_saved: "Pelanggan tersimpan",
    logged_out: "Berhasil keluar",
    invalid_login: "Kredensial tidak valid",
    branch: "Cabang Riyadh",
  },
};

export function tFn(lang) {
  return (key) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
}
